module.exports = __webpack_public_path__ + "static/media/Chirripo1.577eb1f0.jfif";